import React, { Fragment } from 'react';
import cx from 'classnames';

import styles from './AboutUsSection.module.scss';

const ContactDetails = ({
  data: { contactDetails },
}: {
  data: {
    contactDetails: {
      section: { title: string; subtitle: string; description: [] };
    }[];
  };
}): JSX.Element => {
  return (
    <div id="contact-us" className={cx('bg-brand-100', styles.container)}>
      {contactDetails.map(({ section }, index: number) => (
        <Fragment key={`section-${index}`}>
          <div className="grid grid-cols-1 lg:grid-cols-5">
            <div className="col-span-2">
              <h3
                className={cx(
                  'font-bold text-white text-center mb-6 lg:mb-0',
                  styles.responsiveTitle,
                )}
              >
                {section.title}
              </h3>
            </div>
            <div className="col-span-3">
              <p
                className={cx(
                  'text-white font-medium mb-4 lg:mb-2 text-left',
                  styles.responsiveLabel,
                )}
              >
                {section.subtitle}
              </p>
              <div className={cx('flex', styles.descriptionContainer)}>
                <div className="flex-col inline-block max-w-[260px] lg:max-w-screen-lg gap-y-1">
                  {section.description.map((item: string, index: number) => (
                    <p
                      className="text-gray-800 text-left text-base"
                      key={index}
                    >
                      {item}
                    </p>
                  ))}
                </div>
              </div>
            </div>
          </div>
          {contactDetails.length - 1 !== index && (
            <div className="h-[2px] w-full bg-gold-50 my-16" />
          )}
        </Fragment>
      ))}
    </div>
  );
};

export default ContactDetails;
